module.exports = __webpack_public_path__ + "static/6f60ed82.closeShopifyAutoFulfilled.png";